import React from 'react';

interface SparklineProps {
  points: number[];
  color?: string;
  width?: number;
  height?: number;
  ariaLabel?: string;
}

export const Sparkline: React.FC<SparklineProps> = ({
  points,
  color = 'var(--accent)',
  width = 120,
  height = 28,
  ariaLabel,
}) => {
  if (!points || points.length === 0) return <svg width={width} height={height} aria-label={ariaLabel} />;
  if (points.length === 1) {
    const y = height / 2;
    return (
      <svg width={width} height={height} aria-label={ariaLabel} style={{ overflow: 'visible', display: 'block' }}>
        <path d={`M 0 ${y} L ${width} ${y}`} fill="none" stroke={color} strokeWidth={1.5} strokeLinecap="round" />
      </svg>
    );
  }
  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min || 1;
  const step = width / (points.length - 1);
  const path = points
    .map((p, i) => {
      const x = i * step;
      const y = height - ((p - min) / range) * (height - 4) - 2;
      return `${i === 0 ? 'M' : 'L'} ${x.toFixed(1)} ${y.toFixed(1)}`;
    })
    .join(' ');
  const cx = (points.length - 1) * step;
  const cy = height - ((points[points.length - 1] - min) / range) * (height - 4) - 2;
  return (
    <svg width={width} height={height} aria-label={ariaLabel} style={{ overflow: 'visible', display: 'block' }}>
      <path d={path} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={cx} cy={cy} r={2} fill={color} />
    </svg>
  );
};
